<div class="headerpage">
  <div class="headerpageright">
    <i class="headerpageicon icon-menu-o" (click)="stateChange()"></i>
    <img (click)="ShowCallInfo()" src="./assets/images/icons/LogoW.png" class="logo" />
  </div>

  <div class="headerleft">
    <div
      class="check-online"
      *ngIf="
        currentInformation?.HasClub ||
        currentInformation?.SafirCourierFleetManagement ||
        currentBranch?.HasOrderOnline ||
        (isCallCenter && hasAnyDelinoSaleMethodBranch)
      ">
      <ssg-menu
        icon="icon-compare_arrows-o"
        [class.warning]="(currentInformation?.SafirApiKey != null && !fleetConnection) || (currentInformation?.HasClub && !smartConnection)"
        class="ssgmenu">
        <ng-container class="menuitem">
          <div class="connection-box">
            <div class="item-connection" *ngIf="currentInformation?.SafirCourierFleetManagement && currentInformation?.SafirApiKey">
              <i
                [ngClass]="{
                  'icon-check_circle-f': fleetConnection,
                  connected: fleetConnection,
                  'icon-info-f': !fleetConnection
                }"></i>
              <span>{{ "ClientApp.Projects.FrameWorkShell.Header.CommunicationFleet" | translate }}</span>

              <ssg-button icon="icon-loop2" (click)="fleetConnectionTest()"></ssg-button>
            </div>
            <div class="item-connection" *ngIf="currentInformation?.HasClub">
              <i
                [ngClass]="{
                  'icon-check_circle-f': smartConnection,
                  connected: smartConnection,
                  'icon-info-f': !smartConnection
                }"></i>
              <span>{{ "ClientApp.Projects.FrameWorkShell.Header.CommunicationSmart" | translate }}</span>

              <ssg-button (click)="HealthCheckClub(false)" icon="icon-loop2"></ssg-button>
            </div>
            <div class="item-connection" *ngIf="currentBranch?.HasOrderOnline || (isCallCenter && hasAnyDelinoSaleMethodBranch)">
              <i
                [ngClass]="{
                  'icon-check_circle-f': delinoConnection,
                  connected: delinoConnection,
                  'icon-info-f': !delinoConnection
                }"></i>
              <span>{{ "ClientApp.Projects.FrameWorkShell.Header.CommunicationDelino" | translate }}</span>

              <ssg-button (click)="HealthCheckDelino()" icon="icon-loop2"></ssg-button>
            </div>
            <div class="item-connection" *ngIf="currentInformation?.PaymentPanelAVA">
              <i
                [ngClass]="{
                  'icon-check_circle-f': linkPaymentConnection,
                  connected: linkPaymentConnection,
                  'icon-info-f': !linkPaymentConnection
                }"></i>
              <span>{{ "ClientApp.Projects.FrameWorkShell.Header.CommunicationPaymentLink" | translate }}</span>
              <ssg-button (click)="HealthCheckClub(true)" icon="icon-loop2"></ssg-button>
            </div>
          </div>
        </ng-container>
      </ssg-menu>
    </div>

    <div class="notifications">
      <span class="notifications-badge" *ngIf="currentInformation.HasUpdate || fleetNotificationCount || delinoIgnoredOrdersInfos.length">
        {{ (currentInformation.HasUpdate ? 1 : 0) + fleetNotificationCount + delinoIgnoredOrdersInfos.length }}
      </span>
      <ssg-menu icon="icon-bell-o" class="notifications-menu">
        <ng-container class="menuitem">
          <div class="notifications-box">
            <div class="notification-item" (click)="updateDialog()" *ngIf="currentInformation.HasUpdate">
              <div class="notification-sign">
                <i class="icon-check_circle-f"></i>
              </div>
              <span
                >{{ "ClientApp.Projects.FrameWorkShell.Header.NewVersionSoftwareAvailable" | translate }} : {{ currentInformation.LastVersion }}</span
              >
            </div>
            <div class="notification-item" *ngIf="fleetNotificationCount" (click)="showNotification()">
              <div class="notification-sign">
                <i class="icon-radio-checked2"></i>
              </div>
              <span
                >{{ "ClientApp.Projects.FrameWorkShell.Header.Number" | translate }} {{ fleetNotificationCount }}
                {{ "ClientApp.Projects.FrameWorkShell.Header.UnseenFleetMessage" | translate }}</span
              >
            </div>

            <ng-container *ngIf="delinoIgnoredOrdersInfos.length > 0">
              <ng-container *ngFor="let info of delinoIgnoredOrdersInfos">
                <div class="notification-item" (click)="showDelino(info.branchId)">
                  <div class="notification-sign">
                    <img class="delino-sign" src="./assets/images/delino-icon.png" loading="lazy" height="32px" alt="Delino Logo" />
                  </div>
                  <span *ngIf="isCallCenter && currentBranch.AccessToAllBranches && info.branchTitle"
                    >{{ "ClientApp.Projects.FrameWorkShell.Header.ForBranch" | translate }} {{ info.branchTitle }}
                  </span>
                  <span
                    >{{ "ClientApp.Projects.FrameWorkShell.Header.Number" | translate }} {{ info.count }}
                    {{ "ClientApp.Projects.FrameWorkShell.Header.DelinoUnseenOrder" | translate }}</span
                  >
                </div>
              </ng-container>
            </ng-container>

            <div class="notification-item" *ngIf="!fleetNotificationCount && !currentInformation.HasUpdate && !delinoIgnoredOrdersInfos.length">
              <div class="notification-sign">
                <i class="icon-radio-checked2"></i>
              </div>
              <span>{{ "ClientApp.Projects.FrameWorkShell.Header.NoNewMessages" | translate }}</span>
            </div>
          </div>
        </ng-container>
      </ssg-menu>
    </div>

    <div class="current-branch" *ngIf="isCallCenter">
      <div class="current-branch-name">
        {{ currentBranch?.Title }}
      </div>
    </div>

    <audio id="bell" src="assets/audio/bell-ding.mp3"></audio>

    <div class="time">
      <div class="datebox">
        <div class="datepick">
          <span>{{ "ClientApp.Projects.FrameWorkShell.Header.FiscalYear" | translate }}: </span> {{ fiscalYear }}
        </div>
        <i class="icon-fiscalyear dateicon"></i>
      </div>

      <div class="d-flex">
        <div class="d-flex">
          <div class="timebox">
            <span class="show-time">{{ TimeString }}</span>
          </div>
          <div class="datebox">
            <span class="datepick">{{ DateString }}</span>
          </div>
        </div>
        <i class="icon-date_range-o dateicon"></i>
      </div>
    </div>
    <div class="infobox">
      <div>
        <div (click)="_IsShowAction = !_IsShowAction" (clickOutside)="closeAction()" class="d-flex">
          <span class="username">{{ displayName }}</span>
          <i class="icon icon-account-cog-outline"></i>
        </div>
        <div class="d-flex justify-content-between">
          <span> {{ "ClientApp.Projects.FrameWorkShell.Header.Login" | translate }}: </span>
          <span>{{ UserEnterTime }}</span>
        </div>
      </div>

      <div class="setting" [ngClass]="{ 'hidesetting ': !_IsShowAction }">
        <div class="settingrow theme-row" (click)="_IsShowTheme = true" (clickOutside)="closeTheme()">
          <i class="icon-color_lens-o"></i>
          <div class="settitle">{{ "ClientApp.Projects.FrameWorkShell.Header.SelectTheme" | translate }}</div>
          <div class="themebox">
            <div class="themedetail sepidz" (click)="setTheme('sepidz')"></div>
            <div class="themedetail gray" (click)="setTheme('gray')"></div>
          </div>
        </div>
        <div class="settingrow theme-row" (click)="_IsShowTheme = true" (clickOutside)="closeTheme()">
          <i class="icon-text_rotation_none-o"></i>
          <div class="settitle">{{ "ClientApp.Projects.FrameWorkShell.Header.LanguageSelect" | translate }}</div>
          <div class="lanq-box">
            <div *ngFor="let len of this.currentLanguage" (click)="changeDirection(len)" class="lanq">
              {{ len.name }}
            </div>
          </div>
        </div>
        <div class="settingrow">
          <i class="icon-database"></i>
          <div (click)="openBackUpDialog()" class="settitle">
            <a
              ><span>{{ "ClientApp.Projects.FrameWorkShell.Header.BackUp.BackUp" | translate }}</span></a
            >
          </div>
        </div>
        <div class="settingrow">
          <i class="icon-loop2"></i>
          <div (click)="updateDialog()" class="settitle">
            <a
              ><span>{{ "ClientApp.Projects.FrameWorkShell.Header.SoftwareUpdate" | translate }}</span></a
            >
          </div>
        </div>
        <div class="settingrow" *hasPermission="['General:UserLocalSetting/ImportAndExportReport', 'Same']">
          <i class="icon-database"></i>
          <div (click)="ImportAndExport()" class="settitle">
            <a
              ><span>{{ "ClientApp.Projects.FrameWorkShell.Header.InputOutputReports" | translate }} </span></a
            >
          </div>
        </div>
        <div class="settingrow" (click)="branchSelect()">
          <i class="icon-date_range-o"></i>
          <div class="settitle">
            <a
              ><span>{{ "ClientApp.Projects.FrameWorkShell.Header.FiscalYear" | translate }}</span></a
            >
          </div>
        </div>
        <div class="settingrow" (click)="showPasswordForm()">
          <i class="icon-lock_open-o"></i>
          <div class="settitle">
            <a
              ><span>{{ "ClientApp.Projects.FrameWorkShell.Header.ChangePassword" | translate }}</span></a
            >
          </div>
        </div>
        <div class="settingrow" (click)="this.isFullScreen = !this.isFullScreen; fullScreen()" *ngIf="!isFullScreen">
          <i class="icon-fullscreen_exit-o"></i>
          <div class="settitle">
            <a
              ><span>{{ "ClientApp.Projects.FrameWorkShell.Header.ViewFullScreen" | translate }}</span></a
            >
          </div>
        </div>
        <div class="settingrow" (click)="this.isFullScreen = !this.isFullScreen; fullScreen()" *ngIf="isFullScreen">
          <i class="icon-fullscreen_exit-o"></i>
          <div class="settitle">
            <a
              ><span>{{ "ClientApp.Projects.FrameWorkShell.Header.StandardModeDisplay" | translate }}</span></a
            >
          </div>
        </div>
        <div class="settingrow" (click)="closeSystem()">
          <i class="icon-power-off"></i>
          <div class="settitle">
            <a
              ><span>{{ "ClientApp.Projects.FrameWorkShell.Header.Logout" | translate }}</span></a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="usericon">
      <input #photoUpload (change)="openImageUpload($event)" type="file" accept="image/png/jpeg/jpg" class="brows-file" />
      <img (click)="photoUpload.click()" [src]="[userAvatar ? userAvatar : 'assets/images/profile.png']" />
    </div>
  </div>
</div>
<div class="desk" [class.showdesk]="showDesk" (clickOutside)="showDesk && (showDesk = false)">
  <div *ngFor="let item of this.commmon.LocalSetting.BookMarkMenu" (click)="openTab(item)" class="desk1 showdesktable">
    <i class="{{ item.icon }} deskicon"></i>
    <div>{{ item.title | translate }}</div>
  </div>
  <i
    class="icon-chevron-down"
    (click)="showDesk = !showDesk"
    [class.rotate]="showDesk"
    [tooltip]="'ClientApp.Projects.FrameWorkShell.Header.Favorite' | translate"></i>
</div>
